import React from "react";
import { Option, none } from "fp-ts/es6/Option";
import { Limit } from "datamodel/limits";

export const { Provider: LimitsContextProvider, Consumer: LimitsContextConsumer } =
  React.createContext<Option<Limit[]>>(none);
